// HUMANPEACE® — restrained motion + deferred media. Loaded as a module (runs once).
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const designMode = Boolean(window.Shopify && window.Shopify.designMode);
const hasIO = 'IntersectionObserver' in window;

function revealAll(root = document) {
  root.querySelectorAll('[data-hp-reveal]:not(.is-in)').forEach((el) => el.classList.add('is-in'));
}

/* 1. Gentle reveal on scroll */
if (reduce || designMode || !hasIO) {
  revealAll();
} else {
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const el = entry.target;
        const delay = Number(el.dataset.hpRevealDelay || 0);
        if (delay) el.style.transitionDelay = `${delay}ms`;
        el.classList.add('is-in');
        io.unobserve(el);
      }
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
  );
  document.querySelectorAll('[data-hp-reveal]:not(.is-in)').forEach((el) => io.observe(el));
}
document.addEventListener('shopify:section:load', (e) => revealAll(e.target));

/* 2. Campaign video: never competes with the poster image for LCP.
      Starts after window load, only when on screen, never with reduced motion or data saver. */
const saveData = Boolean(navigator.connection && navigator.connection.saveData);
function startVideo(video) {
  if (video.dataset.started) return;
  const mobile = window.matchMedia('(max-width: 749px)').matches;
  const src = (mobile ? video.dataset.srcMobile : video.dataset.srcDesktop) || video.dataset.srcDesktop || video.dataset.srcMobile;
  if (!src) return;
  video.dataset.started = '1';
  video.src = src;
  video.play().then(() => video.classList.add('is-playing')).catch(() => {});
}
function initVideos() {
  const videos = document.querySelectorAll('[data-hp-video]');
  if (!videos.length || reduce || saveData) return;
  if (!hasIO) return videos.forEach(startVideo);
  const vio = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const v = entry.target;
      if (entry.isIntersecting) {
        if (!v.dataset.started) startVideo(v);
        else v.play().catch(() => {});
      } else if (v.dataset.started) {
        v.pause();
      }
    }
  }, { threshold: 0.25 });
  videos.forEach((v) => vio.observe(v));
}
if (document.readyState === 'complete') initVideos();
else window.addEventListener('load', initVideos, { once: true });

/* 3. Complete the look: fetch complementary products only when near view */
document.querySelectorAll('[data-hp-complementary]').forEach((host) => {
  const load = async () => {
    try {
      const res = await fetch(host.dataset.url);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const inner = doc.querySelector('[data-hp-complementary]');
      if (inner && inner.querySelector('[data-hp-card]')) {
        host.innerHTML = inner.innerHTML;
        host.hidden = false;
        revealAll(host);
      }
    } catch (err) {
      /* stays hidden */
    }
  };
  if (!hasIO) return void load();
  const cio = new IntersectionObserver((entries) => {
    if (entries.some((e) => e.isIntersecting)) {
      cio.disconnect();
      load();
    }
  }, { rootMargin: '400px 0px' });
  cio.observe(host.parentElement || host); // host may be [hidden] (no box), so watch its section
});
